export default "__VITE_ASSET__CL7T65AH__"